import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { connect } from 'react-redux'
import { Typography, ListItem, IconButton } from '@material-ui/core';
import { NavHashLink } from 'react-router-hash-link';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';


const useStyles = makeStyles((theme) => ({

    link: {
        textTransform: 'capitalize',
        textDecoration: "none",
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.secondary.main
        }
    },
    active: {

        // textDecoration: 'underline',
        color: theme.palette.secondary.main,
        '& >li': {
            borderRadius: '5px',
            backgroundColor: theme.palette.primary.main
        }
    },

    horizontalCategoryList: {
        position: "sticky",
        top: "55px",
        width: '100%',
        backgroundColor: '#fff',
        zIndex: '99',
    }
}));



const MobileCategoryList = (props) => {
    const classes = useStyles();

    const { categoryData } = props

    const [selected, setSelected] = React.useState(0);
    const history = useHistory()

    React.useEffect(() => {
        history.listen((location, action) => {
            const hash = location.hash
            const key = hash.split('#')[1]
            setSelected(key)
        })

    }, [history])



    const menu = categoryData.map(cat => {
        return (
            <NavHashLink smooth to={`#${cat.id}`} key={cat.id} className={classes.link} activeClassName={classes.active} >
                <ListItem>
                    <Typography component="span" variant="subtitle2"> {cat.label.toLowerCase()}</Typography>
                </ListItem >
            </NavHashLink>

        )
    })


    return (
        <div className={classes.horizontalCategoryList}>
            <ScrollMenu
                data={menu}
                arrowLeft={<IconButton><ChevronLeftIcon /></IconButton>}
                arrowRight={<IconButton><ChevronRightIcon /></IconButton>}
                wheel={true}
                scrollToSelected={true}
                selected={selected}
                onSelect={setSelected}
            />
        </div>
    );

}


const mapStateToProps = (state) => {
    const categories = state.categories
    const categoryData = []

    for (let key in categories) {
        if (categories[key].items.length > 0) {
            categoryData.push(categories[key])
        }
    }

    return { categoryData }
}

export default connect(mapStateToProps, {})(MobileCategoryList)
